import React from "react";

interface DashboardLayoutProps {
  businessType: string;
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ businessType, children }) => {
  // const showHeaderAndMenu = ["Laundry", "Carwash", "Saloon"].includes(businessType);

  return (
    // <div className='h-screen flex flex-col'>
    //   {showHeaderAndMenu && <Header Header='Dashboard' />}
    //   <div className='flex flex-1 '>
    //     {showHeaderAndMenu && <Menu />}
        <div className='flex-1 overflow-y-auto'>{children}</div>
    //   </div>
    // </div>
  );
};

export default DashboardLayout;